import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AutorizacaoService} from "../services/autorizacao.service";
import {EnumOperacaoSistema} from "../../../server/lib/permissao/EnumOperacaoSistema";
import {Usuario} from "../../../server/domain/Usuario";
import { map, filter, take } from 'rxjs/operators';
import {ConstantsService, RecursosEnum} from "../fidelidade/ConstantsService";
import {temPublicacaoCatalogoIfoodHabilitada} from '../canais-venda/canais-venda.logic';
@Injectable({
  providedIn: 'root'
})
export class AuthLojaGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if(route.params.nometab === 'usuarios') {
          if(RotaGuardClient.gerenciarUsuariosLoja(user))
            return true;

          this.router.navigate(['/admin/login']);
          return false;
        }

        if (RotaGuardClient.gerenciaLoja(user)) {
          return true;
        } else {
          this.router.navigate(['/admin/login']);
          return false;
        }
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthContaCellcoinGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if(RotaGuardClient.visualizarContaCellcoin(user))
          return true;

        return this.router.createUrlTree(['/admin/index']);
      })
    );
  }
}


@Injectable({
  providedIn: 'root'
})
export class AuthProdutosGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (RotaGuardClient.cadastrarProdutos(user)) {
          return true;
        } else {
          this.router.navigate(['/admin/login']);
          return false;
        }
      })
    );
  }

}

@Injectable({
  providedIn: 'root'
})
export class AuthPublicacaoCatalogoIfoodGuard implements CanActivate {
  constructor(private router: Router, private constantsService: ConstantsService) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.constantsService.empresa$.pipe(
      filter(empresa => !!empresa?.id),
      take(1),
      map(empresa => temPublicacaoCatalogoIfoodHabilitada(empresa)
        ? true
        : this.router.createUrlTree(['/admin/produtos-v2']))
    );
  }
}


@Injectable({
  providedIn: 'root'
})
export class AuthEstoqueGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (RotaGuardClient.gerenciarEstoque(user)) {
          return true;
        } else {
          this.router.navigate(['/admin/login']);
          return false;
        }
      })
    );
  }

}

@Injectable({
  providedIn: 'root'
})
export class AuthNoticacoesGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (RotaGuardClient.cadastrarNotificacoes(user)) {
          return true;
        } else {
          this.router.navigate(['/admin/login']);
          return false;
        }
      })
    );
  }

}

@Injectable({
  providedIn: 'root'
})
export class AuthContatosGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (RotaGuardClient.cadastrarContatos(user)) {
          return true;
        } else {
          this.router.navigate(['/admin/login']);
          return false;
        }
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthPedidosGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (RotaGuardClient.editarPedido(user)) {
          return true;
        } else {
          this.router.navigate(['/admin/login']);
          return false;
        }
      })
    );

  }

}


@Injectable({
  providedIn: 'root'
})
export class AuthRecursoGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService,
              private constantsService: ConstantsService) {

  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        const recurso = route.data && route.data.recurso ?
          route.data.recurso :
          RotaGuardClient.obtenhaRecursoDaRota(route);
        const modulo = route.data && route.data.modulo ? route.data.modulo : null;
        // rota que também abre para admin do MeuCardápio mesmo sem o recurso na empresa
        const admin = route.data && route.data.ouAdminMeuCardapio && user && (user.admin || user.superadmin);

        if((!recurso && !modulo) || admin ||
          RotaGuardClient.possuiRecurso(user, recurso) ||
          RotaGuardClient.possuiRecurso({empresa: this.constantsService.getEmpresaAtual()}, recurso) ||
          RotaGuardClient.possuiModulo(user, modulo) ||
          RotaGuardClient.possuiModulo({empresa: this.constantsService.getEmpresaAtual()}, modulo) ||
          RotaGuardClient.possuiModulo(user, route.data ? route.data.moduloAlternativo : null) ||
          RotaGuardClient.possuiModulo({empresa: this.constantsService.getEmpresaAtual()}, route.data ? route.data.moduloAlternativo : null))
          return true;

        return this.router.createUrlTree(['/admin/index']);
      })
    );
  }

}


@Injectable({
  providedIn: 'root'
})
export class AuthSuperAdminGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }
  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (user && user.admin) {
          return true;
        } else {
          return false;
        }
      })
    );

  }

}

/** Admin do MeuCardápio (admin ou superadmin) — mesma regra que o backend aplica nas rotas de QA da Mia. */
@Injectable({
  providedIn: 'root'
})
export class AuthAdminMeuCardapioGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (user && (user.admin || user.superadmin)) {
          return true;
        } else {
          return this.router.createUrlTree(['/admin/index']);
        }
      })
    );

  }

}

@Injectable({
  providedIn: 'root'
})
export class AuthUsuarioSuperAdminGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (user && user.superadmin) {
          return true;
        } else {
          return this.router.createUrlTree(['/superadmin/empresas']);
        }
      })
    );

  }

}

@Injectable({
  providedIn: 'root'
})
export class AuthAnalyticsGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService,
              private constantsService: ConstantsService) {}

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        const empresaAtual = this.constantsService.getEmpresaAtual();
        const possuiRecurso = RotaGuardClient.possuiRecurso(user, RecursosEnum.ANALYTICS_CARDAPIO) ||
          this.constantsService.possuiRecurso(empresaAtual, RecursosEnum.ANALYTICS_CARDAPIO);

        if (user && possuiRecurso && (user.superadmin || RotaGuardClient.gerenciaLoja(user))) {
          return true;
        }

        return this.router.parseUrl('/admin/index');
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthPainelSuporteGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        if (RotaGuardClient.gerenciarPainelSuporte(user)) {
          return true;
        } else {
          return this.router.createUrlTree(['/superadmin/empresas']);
        }
      })
    );

  }

}

export class RotaGuardClient{
  private static fallbackRecursosLegados: any = {
    atendimento_garcom: 'garcom',
    controle_fiado: 'controle fiado',
    tabela_precos: 'tabela de precos',
    comissionamento: 'comissionamento',
    google_maps_taxas: 'google api maps',
    chatbot_instagram: 'chatbot instagram',
    dominio_proprio: 'dominio proprio',
    operador_extra: 'operador extra',
    estoque: 'controle de estoque',
    fiscal: 'fiscal',
    kds_cozinha: 'kds'
  };

  static possuiRecurso(usuario: any, slugRecurso: string | Array<string>) {
    if(Array.isArray(slugRecurso))
      return slugRecurso.some(recurso => RotaGuardClient.possuiRecurso(usuario, recurso));

    const empresa = usuario ? usuario.empresa : null;

    if(!empresa || !slugRecurso) return false;

    if(Array.isArray(empresa.recursosAtivos) &&
      empresa.recursosAtivos.some((recurso: string) => recurso === slugRecurso))
      return true;

    const moduloLegado = RotaGuardClient.fallbackRecursosLegados[slugRecurso];
    if(!moduloLegado || !Array.isArray(empresa.modulos)) return false;

    return empresa.modulos.some((modulo: any) => modulo.nome === moduloLegado);
  }

  static possuiModulo(usuario: any, nomeModulo: string) {
    const empresa = usuario ? usuario.empresa : null;

    if(!empresa || !nomeModulo || !Array.isArray(empresa.modulos)) return false;

    return empresa.modulos.some((modulo: any) => modulo.nome === nomeModulo);
  }

  static obtenhaRecursoDaRota(route: ActivatedRouteSnapshot) {
    if(route.params.nometab)
      return RotaGuardClient.obtenhaRecursoPorTabLoja(route.params.nometab);

    if(route.params.parceiro)
      return RotaGuardClient.obtenhaRecursoPorParceiroIntegracao(route.params.parceiro);

    if(route.params.formapagamento)
      return RotaGuardClient.obtenhaRecursoPorFormaPagamento(route.params.formapagamento);

    return null;
  }

  static obtenhaRecursoPorFormaPagamento(formaPagamento: string) {
    const nome = String(formaPagamento || '').toLowerCase();

    if(!nome || nome === 'offline' || nome === 'onlinemci')
      return null;

    return 'integracao_gateway_pagamento';
  }

  static obtenhaRecursoPorTabLoja(nometab: string) {
    const tab = String(nometab || '').toLowerCase();
    const recursosPorTab: any = {
      impressao: ['impressao_avancada', 'kds_cozinha'],
      ifood: 'integracao_marketplaces_delivery',
      keeta: 'integracao_marketplaces_delivery',
      '99food': 'integracao_marketplaces_delivery'
    };

    return recursosPorTab[tab] || null;
  }

  static obtenhaRecursoPorParceiroIntegracao(parceiro: string) {
    const nome = String(parceiro || '').toLowerCase();
    const recursosPorParceiro: any = {
      pagarme: 'integracao_gateway_pagamento',
      pagseguro: 'integracao_gateway_pagamento',
      mercadopago: 'integracao_gateway_pagamento',
      ecletica: 'integracao_pdv_parceiros',
      saipos: 'integracao_pdv_parceiros',
      opendelivery: 'integracao_delivery_parceiros',
      fooddelivery: 'integracao_delivery_parceiros',
      foodydelivery: 'integracao_delivery_parceiros',
      ifood: 'integracao_marketplaces_delivery',
      '99food': 'integracao_marketplaces_delivery',
      keeta: 'integracao_marketplaces_delivery'
    };

    return recursosPorParceiro[nome] || null;
  }

  static alterarPedido(usuario){
    if(usuario && usuario.operador) return true;
    return   RotaGuardClient.temUmaDasPermissoes(usuario, [EnumOperacaoSistema.CancelarPedido, EnumOperacaoSistema.AterarStatusPedido]);
  }

  static cancelarPedido(usuario: any)
  {
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.CancelarPedido)
  }

  static alterarStatusPedido(usuario: any) {
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.AterarStatusPedido)
  }

  static editarPedido(usuario: any){
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.EditarPedido)
  }

  static adicionarPontosFidelidade(usuario: any){
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.PontuarFidelidadeManual)
  }

  static resgatarBrindesFidelidade(usuario: any){
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.TrocarBrindesFidelidadeManual)
  }


  static gerenciaLoja(usuario: any){
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.GerenciarLoja)
  }

  static gerenciarUsuariosLoja(usuario: any){
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.GerenciarUsuariosLoja)
  }

  static visualizarContaCellcoin(usuario: any) {
    if(usuario && (usuario.admin || usuario.superadmin))
      return true;

    return RotaGuardClient.temPermissaoOperacaoDireta(usuario, EnumOperacaoSistema.VisualizarContaCellcoin);
  }

  static transferirSaldoCellcoin(usuario: any) {
    if(usuario && (usuario.admin || usuario.superadmin))
      return true;

    return RotaGuardClient.temPermissaoOperacaoDireta(usuario, EnumOperacaoSistema.TransferirSaldoCellcoin);
  }

  static cadastrarProdutos(usuario: any){
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.CadastrarProduto)
  }

  static gerenciarEstoque(usuario: any){
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.GerenciarEstoque)
  }

  static operadorKDS(usuario: any){
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.OperadorKDS)
  }

  static cadastrarNotificacoes(usuario: any){
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.CadastrarNotificacoes)
  }

  static operarCaixa(usuario: any) {
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.OperarCaixa)
  }


  static cadastrarContatos(usuario: any){
    //login antigos setados como operador ainda
    if(usuario && usuario.operador) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.CadastrarContatos)
  }

  static alterarPrecoCardapioCompartilhado(usuario: any) {
    if( usuario && (usuario.admin || usuario.adminRede)) return true;
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.AlterarPrecoCardapioCompartilhado)
  }

  static podeEditarExibicaoOpcoes(usuario: any, empresa: any) {
    if(!empresa?.catalogo?.compartilhado) return true;

    const redeDoUsuario = String(usuario?.adminRede || '').trim().toUpperCase();
    if(!empresa?.id) return !!redeDoUsuario;

    const redeDaEmpresa = String(empresa?.rede || empresa?.dadosRede?.grupo || '').trim().toUpperCase();

    return !!redeDoUsuario && redeDoUsuario === redeDaEmpresa;
  }


  static visualizaRelatorios(usuario: any){
    return RotaGuardClient.temPermissaoOperacao(usuario, EnumOperacaoSistema.VisulizarVendas)
  }

  static gerenciarPainelSuporte(usuario: any) {
    if (usuario && usuario.superadmin) {
      return true;
    }

    return RotaGuardClient.temPermissaoOperacaoDireta(usuario, EnumOperacaoSistema.GerenciarPainelSuporte);
  }

  static temUmaDasPermissoes(usuario: Usuario, codigosOperacoes: Array<number>){
    let temUmaPermissao = false;

    codigosOperacoes.forEach((operacao) => {
     if( RotaGuardClient.temPermissaoOperacao(usuario, operacao))
       temUmaPermissao = true;
    })

    return temUmaPermissao;
  }

  static temPermissaoOperacao(usuario: any, codigoOperacao: number){
    if(usuario){
      if(usuario.admin || usuario.adminRede) return  true;

      if(usuario.papeis){
        let temPapel = usuario.papeis.find((papel: any) => {
          let temOperacao = papel.operacoes.find((operacao: any) => operacao.id === codigoOperacao) != null

          return temOperacao;
        })  != null

        return temPapel;
      } else {
        //login antigos setados  papeis ainda
        if(usuario.adminRede) return true;
      }
    }

    return false;
  }

  private static temPermissaoOperacaoDireta(usuario: any, codigoOperacao: number) {
    if (!usuario || !usuario.papeis) {
      return false;
    }

    return usuario.papeis.find((papel: any) => {
      return papel.operacoes && papel.operacoes.find((operacao: any) => operacao.id === codigoOperacao) != null;
    }) != null;
  }

}
